(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-image-overlay"]) return;
  try {
    
  document.querySelector('#logo-upload').addEventListener('change', async (event) => {
  const file = event.target.files[0];
  const formData = new FormData();
  formData.append('logo', file);

  const response = await fetch('http://your-server.com/upload', {
    method: 'POST',
    body: formData
  });

  const png = await response.text();

  // Overlay the SVG on the product image
  // This will depend on how your product images are structured
  document.querySelector('#product-image').innerHTML = png;
});

  } catch(e) { console.error(e); }
})();
})();
